export default "__VITE_ASSET__OfQKVGuG__"